import { render, staticRenderFns } from "./TheManageProfilePicturesModal.vue?vue&type=template&id=99b2fb60&scoped=true"
import script from "./TheManageProfilePicturesModal.vue?vue&type=script&lang=js"
export * from "./TheManageProfilePicturesModal.vue?vue&type=script&lang=js"
import style0 from "./TheManageProfilePicturesModal.vue?vue&type=style&index=0&id=99b2fb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b2fb60",
  null
  
)

export default component.exports